import { render, staticRenderFns } from "./escalated-alert-table-tab.vue?vue&type=template&id=3ae268c6&"
import script from "./escalated-alert-table-tab.vue?vue&type=script&lang=ts&"
export * from "./escalated-alert-table-tab.vue?vue&type=script&lang=ts&"
import style0 from "./escalated-alert-table-tab.vue?vue&type=style&index=0&land=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports